(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../button"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../button"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.button);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _button) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _button = _interopRequireDefault(_button);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-result-page"
      }, [!_vm.iconSlot ? _c('p', {
        class: ['nx-result-page__icon', _vm.type]
      }) : _vm._t("icon"), _c('p', {
        staticClass: "nx-result-page__title",
        attrs: {
          "aria-label": _vm.ariaLabelTitle || _vm.title
        }
      }, [_vm._v(_vm._s(_vm.title))]), _vm.description ? _c('p', {
        staticClass: "nx-result-page__desc",
        domProps: {
          "innerHTML": _vm._s(_vm.description)
        }
      }) : _vm._e(), _vm.feedBack ? _c('p', {
        class: ['nx-result-page__feedback', _vm.description ? 'mt72' : '']
      }, [_c('nx-button', {
        attrs: {
          "round": "",
          "position": "center",
          "size": "normal",
          "type": "primary"
        },
        on: {
          "click": _vm.onFeedBack
        }
      }, [_vm._v(_vm._s(_vm.btnText))])], 1) : _vm._e()], 2);
    },
    name: 'nx-result-page',
    props: {
      type: String,
      title: String,
      ariaLabelTitle: String,
      description: String,
      feedBack: {
        type: Boolean,
        default: true
      },
      btnText: {
        type: String,
        default: '完成'
      }
    },
    components: (0, _defineProperty2.default)({}, _button.default.name, _button.default),
    computed: {
      iconSlot: function iconSlot() {
        return this.$slots.icon;
      }
    },
    methods: {
      onFeedBack: function onFeedBack() {
        this.$emit('click');
      }
    }
  };
  _exports.default = _default;
});